import React from "react";
import {
  MdBuild,
  MdBatteryChargingFull,
  MdSettingsBackupRestore,
  MdHomeRepairService,
} from "react-icons/md";
import styles from "./Services.module.css";

export default function Services() {
  const serviceItems = [
    {
      icon: <MdBuild size={24} />,
      title: "New Tyres & Accessories",
    },
    {
      icon: <MdBatteryChargingFull size={24} />,
      title: "Batteries",
    },
    {
      icon: <MdHomeRepairService size={24} />,
      title: "Tyre Puncture",
    },
    {
      icon: <MdSettingsBackupRestore size={24} />,
      title: "Tyre Fitting",
    },
  ];

  const stats = [
    { value: "2500+", label: "Service Points" },
    { value: "20,000+", label: "Customers Serviced" },
    { value: "+10", label: "Corporate/Fleet Owners" },
    { value: "4.7", label: "Customer Rating" },
  ];

  return (
    <section className={styles.servicesSection}>
      <div className={styles.bgOverlay} />
      <div className={styles.container}>
        <div className={styles.grid}>
          {/* Left Text and list */}
          <div className={styles.textColumn}>
            <h2 className={styles.headline}>
              EXPERIENCE THE BEST <br />
              <span className={styles.highlightText}>
                TYRE RELATED SERVICES
              </span>
            </h2>
            <div className={styles.servicesGrid}>
              {serviceItems.map((item, idx) => (
                <div key={idx} className={styles.serviceItem}>
                  <div className={styles.iconCircle}>{item.icon}</div>
                  <span className={styles.itemTitle}>{item.title}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right illustration / pulse circle */}
          <div className={styles.illustrationColumn}>
            <div className={styles.pulseContainer}>
              <div className={styles.pulseRing}></div>
              <img
                alt="Service Experience"
                className={styles.roundImage}
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuDt6kGjFYwyrE5RfpoLiY6lU4dBFmZiOiy9pgo4uHGlQ-sjGVCgVXROqaTxFpLeDghMZGhCSaCOnrzml0T0JYPsxXE0Fn49HkF4P8OmSOCYBp7ny85-smQgFNI6aqTXOvOAtCHqz9sIIpjSiiiFsm9HAkN4t_Q-IxSkOIOa5xTTmaopXr4m6yvot_xe7cAmAISIzzfGvH5W_avYV9tCMZdZ3qX4HNTNsQQDWOnCCjd1jEfnETxwp1NNCDfB7BECNts_-olAAV5Yxg"
                referrerPolicy="no-referrer"
              />
            </div>
          </div>
        </div>

        {/* Stats Row */}
        <div className={styles.statsRow}>
          {stats.map((stat, idx) => (
            <div key={idx} className={styles.statCell}>
              <div className={styles.statValue}>{stat.value}</div>
              <div className={styles.statLabel}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
